import type { AlertSeverity, HostStatus } from '@/core/infra_types'

export type MonitoringTone = 'neutral' | 'success' | 'warning' | 'critical' | 'info'

export const TONE_RING: Record<MonitoringTone, string> = {
  neutral:  'ring-slate-200/70 dark:ring-slate-700/60',
  success:  'ring-emerald-300/60 dark:ring-emerald-500/30',
  warning:  'ring-amber-300/60 dark:ring-amber-500/30',
  critical: 'ring-rose-300/60 dark:ring-rose-500/30',
  info:     'ring-sky-300/60 dark:ring-sky-500/30',
}

export const TONE_TEXT: Record<MonitoringTone, string> = {
  neutral:  'text-slate-900 dark:text-slate-50',
  success:  'text-emerald-700 dark:text-emerald-300',
  warning:  'text-amber-700 dark:text-amber-300',
  critical: 'text-rose-700 dark:text-rose-300',
  info:     'text-sky-700 dark:text-sky-300',
}

export const TONE_GLYPH: Record<MonitoringTone, string> = {
  neutral:  'text-slate-400 dark:text-slate-500',
  success:  'text-emerald-500',
  warning:  'text-amber-500',
  critical: 'text-rose-500',
  info:     'text-sky-500',
}

export const TONE_RIBBON: Record<MonitoringTone, string> = {
  neutral:  'bg-slate-300 dark:bg-slate-600',
  success:  'bg-emerald-500',
  warning:  'bg-amber-500',
  critical: 'bg-rose-500',
  info:     'bg-sky-500',
}

export const SEVERITY_TONE: Record<AlertSeverity, MonitoringTone> = {
  critical: 'critical',
  warning:  'warning',
  info:     'info',
}

export const HOST_STATUS_TONE: Record<HostStatus, MonitoringTone> = {
  online:   'success',
  degraded: 'warning',
  offline:  'critical',
}
